var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _polygon, _path20, _polygon2, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrioritise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 663.81023,
    height: 579.74866,
    viewBox: "0 0 663.81023 579.74866",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M779.295,289.70038H422.88559a13.6248,13.6248,0,0,1-13.609-13.609V173.7347a13.6248,13.6248,0,0,1,13.609-13.609H809.46a13.62481,13.62481,0,0,1,13.609,13.609v72.19165A43.82337,43.82337,0,0,1,779.295,289.70038Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M656.35442,196.5287H493.6012a3.50978,3.50978,0,1,1,0-7.01956H656.35442a3.50978,3.50978,0,0,1,0,7.01956Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M738.743,210.88379H493.6012a3.50978,3.50978,0,1,1,0-7.01956H738.743a3.50978,3.50978,0,0,1,0,7.01956Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M738.743,227.3615H493.6012a3.50978,3.50978,0,1,1,0-7.01956H738.743a3.50978,3.50978,0,0,1,0,7.01956Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M738.743,243.83921H493.6012a3.50978,3.50978,0,1,1,0-7.01956H738.743a3.50978,3.50978,0,0,1,0,7.01956Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M738.743,260.31691H493.6012a3.50978,3.50978,0,1,1,0-7.01955H738.743a3.50978,3.50978,0,0,1,0,7.01955Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M686.63951,383.87986H281.70392a13.6248,13.6248,0,0,1-13.609-13.609V249.54791a13.6248,13.6248,0,0,1,13.609-13.609H686.63951a13.6248,13.6248,0,0,1,13.609,13.609V370.27083A13.6248,13.6248,0,0,1,686.63951,383.87986Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M647.295,374.70038H290.88559a13.6248,13.6248,0,0,1-13.609-13.609V258.7347a13.6248,13.6248,0,0,1,13.609-13.609H677.46a13.62481,13.62481,0,0,1,13.609,13.609v72.19165A43.82337,43.82337,0,0,1,647.295,374.70038Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M524.35442,281.5287H361.6012a3.50978,3.50978,0,1,1,0-7.01956H524.35442a3.50978,3.50978,0,0,1,0,7.01956Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M606.743,295.88379H361.6012a3.50978,3.50978,0,1,1,0-7.01956H606.743a3.50978,3.50978,0,0,1,0,7.01956Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M606.743,312.3615H361.6012a3.50978,3.50978,0,1,1,0-7.01956H606.743a3.50978,3.50978,0,0,1,0,7.01956Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M606.743,328.83921H361.6012a3.50978,3.50978,0,1,1,0-7.01956H606.743a3.50978,3.50978,0,0,1,0,7.01956Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M606.743,345.31691H361.6012a3.50978,3.50978,0,1,1,0-7.01955H606.743a3.50978,3.50978,0,0,1,0,7.01955Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M407.62431,477.38287a26.16382,26.16382,0,1,1,26.16383-26.16382A26.16383,26.16383,0,0,1,407.62431,477.38287Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M417.94786,448.6382h-7.74261v-7.74272a2.58094,2.58094,0,0,0-5.16187,0v7.74272h-7.74272a2.5809,2.5809,0,0,0,0,5.16179h7.74272v7.74271a2.58094,2.58094,0,0,0,5.16187,0V453.8h7.74261a2.5809,2.5809,0,1,0,0-5.16179Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M484.17171,477.38287a26.16382,26.16382,0,1,1,26.16383-26.16382A26.16383,26.16383,0,0,1,484.17171,477.38287Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M494.49526,448.6382H473.84805a2.5809,2.5809,0,0,0,0,5.16179h20.64721a2.5809,2.5809,0,1,0,0-5.16179Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M560.71911,477.38287a26.16382,26.16382,0,1,1,26.16383-26.16382A26.16383,26.16383,0,0,1,560.71911,477.38287Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M575.43837,449.97615,568.021,439.14981a2.19976,2.19976,0,0,0-3.6294,2.48662l4.797,7.00173H550.39548a2.5809,2.5809,0,1,0,0,5.16179h19.02923l-5.03307,7.34623a2.19977,2.19977,0,0,0,3.6294,2.48663l7.41733-10.82635a2.9026,2.9026,0,0,0,0-2.83031Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "460.467 565.314 448.382 565.313 442.632 518.694 460.47 518.695 460.467 565.314",
    fill: "#a0616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M728.9879,738.04754l-37.16649-.00139v-.47005a14.467,14.467,0,0,1,14.46623-14.466h.00089l6.78893-5.15044,12.66665,5.15124,3.2444.00011Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "553.032 552.243 541.862 556.856 518.748 515.964 535.235 509.155 553.032 552.243",
    fill: "#a0616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M826.33411,723.85849l-34.35139,14.18905-.17947-.43443a14.467,14.467,0,0,1,7.84712-18.89339l.00082-.00034,4.30816-7.3523,13.67383-.07519,2.99866-1.23863Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M787.30916,476.14147s-9.36371-29.53122-5.482-41.61971l21.58832-1.31013,2.47006,43.57472-12.33889,50.38252a8.59386,8.59386,0,1,1-14.46257-3.10407Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#a0616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M801.08451,415.64487l-3.23606-14.23769a41.68737,41.68737,0,0,0-18.54393-26.10368h0a18.24983,18.24983,0,0,0-19.26358.013h0a18.20679,18.20679,0,0,0-6.29481,24.048c6.66285,12.30722,6.697,26.25287,16.55673,26.64532l-.38609,5.1206,13.57992,29.668,26.57532-6.70787Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M783.29875,480.00006s6.91364,22.99541,1.46174,42.62691-9.847,66.98262-9.847,66.98262l40.69827,100.50106-18.93344,4.88117-60.49439-98.82747L730.47731,699.8163l-18.25123.74865L698.44976,596.76331l10.92737-104.39684Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M786.356,500.06847l.11054-.15505c5.90356-8.26511-2.97541-28.126-4.31456-31.00508h0a7.22818,7.22818,0,0,0,4.94757-7.71971l-.57729-4.90723-.60174-4.81333,4.31092-4.31093.01212-.10751,2.48087-21.70758,3.60712-14.41795a31.65377,31.65377,0,0,0-8.98437-30.6762l-8.33779-1.32394-10.133-9.7633H752.53571l-5.60284,5.35307c-10.45926,1.83438-8.25612,1.23543-17.24044,12.01661l-11.2977,32.32106,1.01843,4.61118-.003,6.25428,1.60351,18.45029a8.95413,8.95413,0,0,0-2.124,7.7454l.3405,1.7024h0c-2.67035,1.14439-5.21844,21.48181-5.82723,24.32253l-.90938,4.24338c-.778,1.0266-5.91325,7.87385-5.91325,9.74569,0,.281.20744.5527.65262.85406,3.49961,2.36971,24.63949,4.8051,33.20047,1.37939,9.11912-3.64618,45.36908,1.8237,45.73431,1.87943Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M677.09464,437.01113s26.26853-16.42365,38.94287-15.675l6.64559,20.58174-41.58642,13.24487-51.868.59814a8.59386,8.59386,0,1,1-.59578-14.77993Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#a0616a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M739.11577,435.2852l12.98307-6.6801a41.68743,41.68743,0,0,0,20.66259-24.46093h0a18.24985,18.24985,0,0,0-4.81033-18.65333h0a18.20678,18.20678,0,0,0-24.858-.10708c-10.26,9.51811-23.75764,13.02452-21.68209,22.67124l-5.0554.90141L691.0047,429.49747,704.12,453.56472Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 492.73781,
    cy: 178.45519,
    r: 24.42835,
    fill: "#a0616a"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M744.08192,310.37652c1.75078-.052,1.14977-3.35211,2.56032-4.40485q.01032.04791.02135.09563a3.43811,3.43811,0,0,0,6.57026.28031,5.22535,5.22535,0,0,1,3.31767-3.48052c.08784,3.05877,2.40156,5.71351,5.16177,7.03464s5.90744,1.541,8.96719,1.58623a39.57727,39.57727,0,0,1,9.13064.69153c2.967.74871,5.85306,2.50911,7.12072,5.29426,1.26772,2.78516.36322,6.61972-2.40873,7.916,2.1474.01144,3.96954,1.78345,4.712,3.79842a15.08241,15.08241,0,0,1,.4656,6.37329c-.6035,7.89923-2.07489,16.40368-7.82684,21.85135-4.3838,4.15191-10.65854,5.82447-16.69634,5.80032-6.0378-.02421-4.97615-.57919-10.8141-2.1202,6.00378.6727,4.36566-26.14917-5.55457-27.2356a7.39155,7.39155,0,0,1-.25668-.7259,8.26069,8.26069,0,0,0-5.159-5.47073,6.4063,6.4063,0,0,0-7.002,2.11905C729.9987,323.78451,733.96459,310.677,744.08192,310.37652Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M897.41126,738.84925H864.22473l-.14257-.25879c-.42432-.76953-.834-1.585-1.2168-2.42285-3.41846-7.31836-4.86328-15.68848-6.13819-23.07325l-.96-5.5664a3.43688,3.43688,0,0,1,5.41016-3.36231q7.56519,5.50488,15.13623,10.999c1.91113,1.39062,4.09375,3,6.18408,4.73925.20166-.97949.4126-1.96191.62354-2.93066a3.43916,3.43916,0,0,1,6.28076-1.08594l3.88281,6.23828c2.832,4.55567,5.33154,9.04493,4.82227,13.88672a.75679.75679,0,0,1-.01319.17578,10.94736,10.94736,0,0,1-.56347,2.33106Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#f0f0f0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M930.72065,739.567l-315.3575.30731a1.19069,1.19069,0,0,1,0-2.38135l315.3575-.30731a1.19069,1.19069,0,0,1,0,2.38135Z",
    transform: "translate(-268.09489 -160.12567)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrioritise);
export default __webpack_public_path__ + "static/media/prioritise.c146454d4d2ba4841b4c0e63bf2fdbbd.svg";
export { ForwardRef as ReactComponent };